import { Common, ResolveState } from '../../common';
import { ErrorResult } from '../models/error-result';
import { Updater } from '../models/updater-interface';

export class OnlyArrowFunctionsUpdater implements Updater {
    /**
     * Resolves only-arrow-functions linter error
     * @param {string} fileData String contents of file containing linter error
     * @param {ErrorResult} error Object representing linter error
     * @returns {Promise<string>} Updated file content after resolving linter error or the original contents if unable to resolve
     */
    public update(fileData: string, error: ErrorResult): Promise<string> {
        const parameterRegex = /(?<=function\s*\()[^)]*/;
        const targetRegex = /function\s*\([^)]*\)/;

        const parameters = fileData.match(parameterRegex);
        const replaceString = parameters ? parameters[0] : '';
        const result = Common.replaceInString(fileData, targetRegex, `(${replaceString}) =>`);

        error.resolved = ResolveState.Resolved;
        return new Promise(resolve => resolve(result));
    }
}
